import { useCallback, useEffect, useState } from "react";
import { INoticia } from "../../../Interfaces/model/INoticia";
import { Loading } from "../../../components/loading";
import { SearchBar } from "../../../components/searchBar";
import { WhiteCard } from "../../../components/whiteCard";
import noticiaService from "../../../services/noticiaService";
import { Notify } from "../../../utils/notify";
import { scrollUp } from "../../../utils/pageUtils";
import { WhiteCardList } from "../../home/styles";
import { Container, LastNewsMessage, NoticiaNotFound, Title } from "./styles";

export const AdminNoticias = () => {
  const [noticia, setNoticias] = useState<INoticia[]>([]);
  const [noticiaDelete, setNoticiasDelete] = useState<any[]>([]);
  const [title, setTitle] = useState<string>("");
  const [isLastNews, setIsLastNews] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isNotFound, setIsNotFound] = useState<boolean>(false);
  const [titleUsed, setTitleUsed] = useState<string>("");

  const hideLoading = useCallback(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 600);
  }, []);

  const getNoticiasRecentes = useCallback(() => {
    setIsNotFound(false);
    noticiaService
      .getNoticias()
      .then((response) => {
        const noticiasEncontradas = response.data;
        setNoticias(noticiasEncontradas);
        setIsLastNews(true);
      })
      .catch(() => {
        Notify.failure("A busca falhou, tente novamente!");
      })
      .finally(() => {
        hideLoading();
      });
  }, [hideLoading]);

  const getNoticiasToDelete = useCallback(() => {
    noticiaService
      .getNoticiasToDelete()
      .then((response) => {
        setNoticiasDelete(response.data);
      })
      .catch(() => {
        Notify.failure("Não foi possível carregar as notícias disponíveis para exclusão.");
      });
  }, []);

  function getNoticiaByTitle() {
    setIsNotFound(false);
    setIsLoading(true);
    if (title !== "") {
      noticiaService
        .getNoticiaByTitle(title)
        .then((response) => {
          const noticiasEncontradas = response.data;
          setNoticias(noticiasEncontradas);
          setIsLastNews(false);
          setTitleUsed(title);
          if (noticiasEncontradas.length === 0) {
            setTimeout(() => {
              setIsNotFound(true);
              Notify.warning("Nenhuma noticia foi encontrada!");
            }, 625);
          }
        })
        .catch((e) => {
          console.log(e);
          Notify.failure("A busca falhou, tente novamente!");
        })
        .finally(() => {
          hideLoading();
        });
    } else {
      getNoticiasRecentes();
    }
  }

  useEffect(() => {
    scrollUp();
    getNoticiasRecentes();
    getNoticiasToDelete();
  }, [getNoticiasRecentes, getNoticiasToDelete]);

  async function handleDeleteNoticia(id: number, titulo: string) {
    if (
      window.confirm(
        `Deseja realmente deletar essa notícia?\n\nTitulo da notícia: ${titulo}`
      )
    ) {
      try {
        await noticiaService.deleteNoticia(id);
        Notify.success("Notícia deletada com sucesso");
        getNoticiasRecentes();
        getNoticiasToDelete();
      } catch (err) {
        console.log(err);
        Notify.failure("Não foi possível deletar a notícia");
      }
    }
  }

  return (
    <Container>
      <Loading isLoading={isLoading} />
      {!isLoading && (
        <>
          <Title>Deletar notícias</Title>
          <SearchBar
            onClick={getNoticiaByTitle}
            placeholder={"Pesquisar notícia"}
            value={title}
            onChange={setTitle}
          />
          {isLastNews && (
            <LastNewsMessage>
              Essas são as últimas notícias postadas
            </LastNewsMessage>
          )}
          {isNotFound && (
            <NoticiaNotFound>
              A busca
              <strong> "{titleUsed}" </strong>
              não obteve nenhum resultado
            </NoticiaNotFound>
          )}
          <WhiteCardList>
            {noticia.map((item) => (
              <WhiteCard
                onClickDelete={() => handleDeleteNoticia(item.id, item.titulo)}
                key={item.id}
                news={item}
              />
            ))}
          </WhiteCardList>
        </>
      )}
     <LastNewsMessage style={{marginTop: "24px"}} >As notícias abaixo podem ser excluidas</LastNewsMessage>
     <WhiteCardList>
            {noticiaDelete.map((item) => (
              item.map((noticia:any) =>(      
              <WhiteCard
                onClickDelete={() => handleDeleteNoticia(noticia.id, noticia.titulo)}
                key={noticia.id}
                news={noticia}
              />
              ))
            ))}
          </WhiteCardList>
    </Container>
  );
};
